<template>
  <main class="account" data-cy="verify-error">
    <section class="account__column account__column--cta">
      <div class="heading-container">
        <h1 data-cy="login-title">{{ $t('pages.verifyError.introHeader') }}</h1>
        <p>
          {{ $t('pages.verifyError.introText') }}
        </p>
      </div>
    </section>
    <section class="account__column account__column--showcase">
      <img src="/img/login.svg" />
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  metaInfo() {
    return {
      title: this.$t('pages.verifyError.pageTitle')
    };
  }
});
</script>
